import cloneDeep from 'lodash/fp/cloneDeep'
import { map, merge } from 'lodash'
import { NamedQueryFilter } from '~/custom_reports/types'

type FilterAdapter = {
  [key: string]: {
    field: string
    path: string
  }
}

export const getFilterParams = (filters: NamedQueryFilter[], filterAdapters: FilterAdapter = {}) => {
  return map(cloneDeep(filters), filter => merge(filter, filterAdapters[filter.id]))
}
